import React from 'react'
import {useSelector} from 'react-redux'
import {RoomsSection} from 'components/Accommodation/Rooms/RoomsSection/RoomsSection'
import {getMetaBrandHasRooms} from 'modules/accommodation/selectors'
import {isVioOfferOrBundleSelected} from 'modules/accommodation/utils'
import {getIsRoomsResultEmpty} from 'modules/searchApi/selectors'

import {Divider} from '@daedalus/atlas/Divider'
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper'

export const ConditionalRooms = ({hotelId}: {hotelId: string}) => {
  const isRoomResultsEmpty = useSelector(getIsRoomsResultEmpty)
  const brandHasRooms = useSelector(getMetaBrandHasRooms)
  const isVioOfferSelected = isVioOfferOrBundleSelected()

  const shouldRenderRooms =
    !isVioOfferSelected && !isRoomResultsEmpty && brandHasRooms
  if (!shouldRenderRooms) return null

  return (
    <>
      <Divider sideMargin="s500" />
      <ContentWrapper paddingX="s500" paddingY="s700">
        <RoomsSection hotelId={hotelId} />
      </ContentWrapper>
    </>
  )
}
